import React from "react";
import Footer from "../Fotter";

function DisclaimerPolicy() {
    return (
        <div>
            <div className="container mx-auto px-4 py-6">
                <h2 className="text-3xl font-semibold text-center text-gray-800 mb-6">Disclaimer Policy</h2>
                <p className="text-lg text-gray-700 leading-relaxed mb-4">
                    The information contained in this website is for general information purposes only. The information is provided by fliptwirls and while we endeavor to keep the information up to date and correct, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability or availability with respect to the website or the information, products, services, or related graphics contained on the website for any purpose. Any reliance you place on such information is therefore strictly at your own risk.
                </p>
                <p className="text-lg text-gray-700 leading-relaxed mb-4">
                    In no event will we be liable for any loss or damage including without limitation, indirect or consequential loss or damage, or any loss or damage whatsoever arising from loss of data or profits arise out of, or in connection with, the use of this website.
                </p>
                <p className="text-lg text-gray-700 leading-relaxed mb-4">
                    Through this website you are able to link to other websites which are not under the control of fliptwirls. We have no control over the nature, content and availability of those sites. The inclusion of any links does not necessarily imply a recommendation or endorse the views expressed within them.
                </p>
                <p className="text-lg text-gray-700 leading-relaxed mb-4">
                    Every effort is made to keep the website up and running smoothly. However, fliptwirls takes no responsibility for, and will not be liable for, the website being temporarily unavailable due to technical issues beyond our control.
                </p>

                <div className="mt-8 ">
                    <h3 className="text-2xl font-medium text-gray-800">Contact Information</h3>
                    <p className="text-lg text-gray-700 mt-2">
                        <strong>Office and Warehouse Address :</strong>
                    </p>
                    {/* <p className="text-lg text-gray-700">Thakur Ji Ki Haweli Jalpa Mata Mandir Ke Pass Rajgarh, Rajgarh Madhya Pradesh, Bharat Pin 465661</p> */}
                    <p className="text-lg text-gray-700 mt-2">Shop No. 4, 105 Jai Bajrang Nagar Keladevi Road, Happy Tower In Front of King George School Dewas, Dewas Madhya Pradesh, 455001</p>
                    <p className="text-lg text-gray-700 mt-2"><strong>Phone:</strong> +91 8047154521</p>
                    <p className="text-lg text-gray-700 mt-2"><strong>Email:</strong> info@fliptwirls.com</p>
                    <p className="text-lg text-gray-700 mt-2"><strong>Website:</strong> www.fliptwirls.com</p>
                </div>

            </div>
            <Footer />
        </div>
    );
}

export default DisclaimerPolicy;
